import React from 'react';
import { Avatar, Tooltip, Typography } from 'antd';
import { showShortName } from '@/shared/helpers/short-name.helper';
import { EEntity } from '@/services/dynamics/enums/entity.enum';
import { getEntityCrmIcon } from '@/services/dynamics/helpers/get-small-crm-icon.helper';
import { MessageIcon } from '@/components/MessageIcon/MessageIcon';
import phoneIcon from '@/public/icons/side-bar/phone.svg';
import mailIcon from '@/public/icons/email.svg';
import { MsgIcon } from '@/public/icons/messengers/MsgIcon';
import { IEntity } from '@/shared/interfaces/entity.interface';
import './EntityItem.scss';

const { Text } = Typography;

export interface EntityItemProps {
  user: IEntity;
  size?: number;
  onOpenEntity: (id: string, type: EEntity) => Promise<void>;
  onMakeCall?: (phone: string, user: IEntity) => void;
  onCreateSms?: (phone: string, user: IEntity) => void;
  onCreateMail?: (email: string, user: IEntity) => void;
}

interface ActionButtonProps {
  tooltip: string;
  onClick?: () => void;
  icon: React.ReactNode;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  tooltip,
  onClick,
  icon,
}) => (
  <Tooltip placement="bottom" title={tooltip} mouseEnterDelay={0.3}>
    <div className="action-icon" onClick={onClick}>
      {icon}
    </div>
  </Tooltip>
);

export function EntityItem({
  user,
  size = 32,
  onOpenEntity,
  onMakeCall,
  onCreateMail,
  onCreateSms,
}: EntityItemProps) {
  const smallEntity = getEntityCrmIcon(user.type);
  const phone: string = user.phones?.[0];
  const email: string = user.emails?.[0];

  return (
    <div className="entity-icon">
      <div
        className="entity-icon__avatar"
        onClick={() => onOpenEntity(user.id, user.type)}
      >
        <Avatar className="avatar" size={size} alt="Avatar">
          {showShortName(user.fullName)}
        </Avatar>
        {smallEntity && (
          <MessageIcon className="small-entity-icon" svgUrl={smallEntity} />
        )}
      </div>
      <div className="entity-icon__info">
        <div className="entity-icon__name">
          <Text ellipsis={{ tooltip: user.fullName }} className="full-name">
            {user.fullName}
          </Text>
        </div>
        <div className="entity-icon-actions">
          {phone && (
            <>
              <ActionButton
                tooltip={`Call ${phone}`}
                onClick={() => onMakeCall?.(phone, user)}
                icon={<MessageIcon svgUrl={phoneIcon} />}
              />
              <ActionButton
                tooltip={`SMS ${phone}`}
                onClick={() => onCreateSms?.(phone, user)}
                icon={<MsgIcon />}
              />
            </>
          )}
          {email && (
            <ActionButton
              tooltip={`Email ${email}`}
              onClick={() => onCreateMail?.(email, user)}
              icon={<MessageIcon svgUrl={mailIcon} />}
            />
          )}
        </div>
      </div>
    </div>
  );
}
